import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Gartner } from "../Logos/Gartner";
var MarketingFooter = function () {
    var theme = useTheme();
    var isMedium = useMediaQuery(theme.breakpoints.up("md"));
    return (_jsxs(Stack, { direction: { xs: "column", md: "row" }, gap: 0.5, sx: { padding: "0 32px" }, alignItems: "center", children: [_jsx(Typography, { variant: "body2", color: "textSecondary", sx: { whiteSpace: "nowrap" }, children: "Recognized by" }), _jsx(Gartner, {}), _jsxs(Typography, { variant: "body2", color: "textSecondary", pl: 1, mt: { xs: "8px", md: "unset" }, sx: { whiteSpace: "nowrap" }, children: [isMedium && "|", " SOC2 Certified | HIPAA Compliant"] })] }));
};
export default MarketingFooter;
